import { render } from "./FindCourses.vue?vue&type=template&id=04c284f2&ts=true"
import script from "./FindCourses.vue?vue&type=script&lang=ts"
export * from "./FindCourses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__